import React, {useEffect, useContext, useCallback} from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getNotifier } from '../../../../../services/notifier';
import { ApiContext } from '../../../../../services/api/api-config';
import  useFormState from '../../../../../hooks/useFormState';
import { SideMenu } from '../../../../../components/Dashboard/SideMenu/SideMenu';
import TopBar from '../../../../../components/Dashboard/TopBar/TopBar';
import { SectionTitle } from '../../../../../components/Dashboard/SectionTitle/SectionTitle';
import Card from '../../../../../components/Dashboard/Card/Card';
import TextInput from '../../../../../components/forms/TextInput/TextInput';
import Button from '../../../../../components/molecules/Button/Button';
import { catStoreGroupTableSGroups } from '../CatStoreGroupUtils';
import { paths } from '../../../../../services/routes/appRoutes';
import "./CatStoreGroupForm.scss"

export default function CatStoreGroupForm() {

  const { id } = useParams();
  const api = useContext(ApiContext);
  const navigate = useNavigate();
  const { form, setForm, bindInput } = useFormState({});
  const loadingId = `Grower.form.${id}`;

  useEffect(() => {
    if (id) {
      api.storeGroups.get(
        {
          id,
          params: {sGroups: catStoreGroupTableSGroups}
        }
      )
        .then(async(storeGroup) => {
          setForm( storeGroup );
        })
        .catch(error => getNotifier().error(error.detail || error.message));
    }
  }, [api, id, setForm]);

  /**
   * Handle create or update material status
   */
  const handleCreateOrUpdateStoreGroup = useCallback(() => {
    const {id} = form;
    const method = id ? 'update' : 'create';
    let storeGroup = null;

    try {
      // brand = prepareBrandForServer(form);
      storeGroup = form;
    } catch (error) {
      return getNotifier().error(error.message||error.detail);            
    }
    
    api.storeGroups[method]({ id, params: storeGroup })
      .then(storeGroupResponse => {
        getNotifier().success(
          id ? 'Actualizado correctamente' : 'Agregado correctamente'
        );
        navigate(paths.catStoreGroup);
      }
    )
      .catch(error => getNotifier().error(error.message || error.detail));
  }, [api, form, navigate]);

  const loading = useSelector(s => !!s.loadingIds[loadingId]);

  return (
    <div className='CatStoreGroupForm'>
      <SideMenu />
      <div className='right-content'>
        <TopBar />
        <div className='main-content'>
          <SectionTitle>
            { !id ? 'AGREGAR CADENA DE TIENDAS' : 'EDITAR CADENA DE TIENDAS' }
          </SectionTitle>
          <div className='row'>
            <Card className='OrderStep1'>
              <div className='row mt-3'>
                <div className='col-12 margin-top-mobile'>
                  <TextInput
                    label="Nombre"
                    placeholder=""
                    {...bindInput('name')}
                    inputProps={
                      {maxLength: 250}
                    }
                  />
                </div>
              </div>
                      
              <div className='d-flex justify-content-center align-items-center buttons-container'>
                <Button
                  className={'btn-primary btn-outline'}
                  onClick={() => window.location.href = paths.catStoreGroup }
                  design={'clear'}
                >
                  Cancel
                </Button>
                <Button 
                  className={`btn-primary btnNextStep`}
                  onClick={handleCreateOrUpdateStoreGroup}
                  disabled={loading}
                >
                  { id ? 'Actualizar' : 'Agregar' }
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
